import { Type } from 'class-transformer';
import {
  ArrayNotEmpty,
  IsArray,
  IsNotEmpty,
  IsString,
  IsOptional,
  IsUUID,
  IsBoolean,
  IsInt,
  IsPositive,
} from 'class-validator';

import type { FileInputValue } from '@vk-hr-tek/ui/input';

export class CreatePolicyVersionDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString({
    message: 'Вы указали неверную дату',
  })
  @IsNotEmpty({
    message: 'Вы забыли указать дату',
  })
  activeFrom: string;

  @IsString({
    message: 'Вы указали неверную дату',
  })
  @IsOptional({
    message: 'Вы указали неверную дату',
  })
  activeTo?: string;

  @IsInt()
  @IsPositive()
  @Type(() => Number)
  @IsOptional()
  acceptancePeriodDays?: number;

  @IsArray()
  @ArrayNotEmpty({
    message: 'Вы забыли прикрепить файл',
  })
  files: FileInputValue[];

  @IsNotEmpty({
    message: 'Вы забыли указать дату',
  })
  documentDate: string;

  @IsOptional()
  documentNumber?: string;

  @IsNotEmpty()
  signatureType: 'pep' | 'unep';

  @IsNotEmpty()
  @IsBoolean()
  withOrder: boolean;
}
